"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyCreateCharacterFigure;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSound = _interopRequireDefault(require("react-sound"));

var _LobbyCreateCharacterFigureModule = _interopRequireDefault(require("./LobbyCreateCharacterFigure.module.scss"));

var _assets = require("../../../../../../../assets");

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getRandomSoundUrl(raceId, gender) {
  var items = ["shout01", "shout02", "shout03", "yes", "no", "hi", "laugh"];
  var random = items[Math.floor(Math.random() * items.length)];
  var filename = "".concat(raceId, "_").concat(gender.slice(0, 1), "_").concat(random, ".wav");
  var randomSrc = "".concat(_assets.ASSETS_RACES, "/sounds/").concat(raceId, "/").concat(filename);
  return randomSrc;
}

function LobbyCreateCharacterFigure(_ref) {
  var _ref$raceId = _ref.raceId,
      raceId = _ref$raceId === void 0 ? "highelf" : _ref$raceId,
      _ref$gender = _ref.gender,
      gender = _ref$gender === void 0 ? "male" : _ref$gender,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      soundSrc = _useState2[0],
      setSoundSrc = _useState2[1];

  var _useState3 = (0, _react.useState)("STOPPED"),
      _useState4 = _slicedToArray(_useState3, 2),
      soundStatus = _useState4[0],
      setSoundStatus = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      soundPos = _useState6[0],
      setSoundPos = _useState6[1];

  var img = "".concat(_assets.ASSETS_RACES, "/figures/").concat(raceId, "_").concat(gender, ".gif");
  var handleOnClickFigure = (0, _react.useCallback)(function () {
    setSoundSrc(getRandomSoundUrl(raceId, gender));
    setSoundStatus("STOPPED");
    setSoundPos(0);
    setSoundStatus("PLAYING");
  }, [gender, raceId]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyCreateCharacterFigureModule.default.figure, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyCreateCharacterFigureModule.default.rotationControls
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CHAR_LEFT_ROTATION,
    className: _LobbyCreateCharacterFigureModule.default.roateLeft
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CHAR_CENTER_ROTATION,
    className: _LobbyCreateCharacterFigureModule.default.roateReset
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CHAR_RIGHT_ROTATION,
    className: _LobbyCreateCharacterFigureModule.default.roateRight
  })), /*#__PURE__*/_react.default.createElement(_reactSound.default, {
    key: soundSrc,
    url: soundSrc,
    position: soundPos,
    volume: 100,
    playStatus: soundStatus,
    onFinishedPlaying: function onFinishedPlaying() {
      return setSoundStatus("STOPPED");
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    className: _LobbyCreateCharacterFigureModule.default.raceFigure,
    alt: "",
    onClick: handleOnClickFigure
  }));
}